import { Link, createFileRoute, notFound } from '@tanstack/react-router'
import { Figure } from '../../components/Figure'
import { SiteFooter } from '../../components/SiteFooter'
import { SiteHeader } from '../../components/SiteHeader'
import { useLocale } from '../../components/use-locale'
import { fmt, getDict, parseLocale } from '../../i18n'
import { DEFAULT_AVATAR } from '../../lib/avatar'
import { formatDuration } from '../../lib/format'
import { seoHead } from '../../lib/seo'
import { SITE_ORIGIN } from '../../lib/site'
import { RANKING_SIZE, getRankingFn } from '../../server-fns/ranking'

export const Route = createFileRoute('/{-$locale}/ranking')({
  beforeLoad: ({ params }) => {
    if (!parseLocale(params.locale)) throw notFound()
  },
  loader: async () => ({ ranking: await getRankingFn() }),
  head: ({ params }) => {
    const locale = parseLocale(params.locale) ?? 'ja'
    const t = getDict(locale)
    return seoHead({
      origin: SITE_ORIGIN,
      locale,
      path: '/ranking',
      title: t.meta.rankingTitle,
      description: fmt(t.meta.rankingDescription, { n: RANKING_SIZE }),
    })
  },
  component: RankingPage,
})

function RankingPage() {
  const { ranking } = Route.useLoaderData()
  const { t, locale, path } = useLocale()
  return (
    <div className="profile-page">
      <SiteHeader variant="solid" />
      <main id="main" className="ranking">
        <h1 className="ranking__title">{t.ranking.title}</h1>
        <p className="ranking__lead">{fmt(t.ranking.lead, { n: RANKING_SIZE })}</p>
        {ranking.length === 0 ? (
          <p className="lp-body">{t.ranking.empty}</p>
        ) : (
          <ol className="ranking__list">
            {ranking.map((r) => (
              <li key={r.handle} className={r.rank <= 3 ? 'ranking__row ranking__row--top' : 'ranking__row'}>
                <Link to={path(`/u/${r.handle}`)} className="ranking__link">
                  <span className="ranking__rank">{fmt(t.ranking.rank, { n: r.rank })}</span>
                  <img
                    className="ranking__avatar"
                    src={r.image ?? DEFAULT_AVATAR}
                    alt=""
                    width={44}
                    height={44}
                    referrerPolicy="no-referrer"
                  />
                  <span className="ranking__who">
                    <span className="ranking__name">{r.name}</span>
                    <span className="ranking__handle">@{r.handle}</span>
                  </span>
                  <span className="ranking__total">
                    <Figure value={formatDuration(r.totalSeconds, locale)} />
                  </span>
                </Link>
              </li>
            ))}
          </ol>
        )}
      </main>
      <SiteFooter />
    </div>
  )
}
